import { WidthContainer } from '@pata-app/ui-document';
import { Button } from '@pata-app/ui-form';
import { Image } from '@pata-app/ui-media';

import React from 'react';

import { TextWithHighlight } from '../../../../components/textWithHighlight/textWithHighlight';
import { getEnv } from '../../../../lib/utils/getEnv';
import { ActionContainer, HeroContent, HeroOverviewContainer, HeroSectionContainer } from './heroSection.styled';

const { VITE_CDN_BASE_URL, VITE_PARTNERS_BASE_URL } = getEnv();

const HeroSection = () => {
  const handleSignUpClick = () => {
    window.location.href = `${VITE_PARTNERS_BASE_URL}/sign-up`;
  };

  const handleBookDemo = () => {
    window.location.href = `https://meetings.hubspot.com/pata/demo`;
  };

  return (
    <HeroSectionContainer>
      <Image
        src={`${VITE_CDN_BASE_URL}/images/image-grooming-hero-image.webp`}
        alt="Lady grooming dog in grooming salon"
        height={2000}
        width={2000}
      />

      <WidthContainer noBackground>
        <HeroOverviewContainer>
          <HeroContent>
            <TextWithHighlight>
              <h1>
                Manage bookings and reduce no-shows with <strong> pet care software </strong>
                built for grooming
              </h1>
            </TextWithHighlight>
            <p>
              Say goodbye to <strong>no-shows and admin stress </strong>
              with booking software made for pet groomers who want to save time and stay organised.
            </p>

            <ActionContainer>
              <Button onClick={handleSignUpClick}>Sign up for free</Button>
              <Button buttonType="secondary" onClick={handleBookDemo}>
                Book a demo
              </Button>
            </ActionContainer>
          </HeroContent>
          <Image
            src={`${VITE_CDN_BASE_URL}/images/image-grooming-hero-image.webp`}
            alt="Dog groomer in salon looking stress free after using Pata booking software"
            height={2000}
            width={2000}
          />
        </HeroOverviewContainer>
      </WidthContainer>
    </HeroSectionContainer>
  );
};

export default HeroSection;
